import { call, put, select, all, takeLatest } from 'redux-saga/effects';
import { adminActionTypes as types } from 'src/redux/actions/adminActions';
import { getAuth, signInWithEmailAndPassword, signOut, updateProfile, reauthenticateWithCredential, EmailAuthProvider, updatePassword } from "firebase/auth";
import { ref as dbRef, get, set, push, update, remove } from "firebase/database";
import { ref as stoRef, uploadBytes, getDownloadURL, listAll, deleteObject } from "firebase/storage";
import notification from 'src/utils/notification';
import adminSelectors from 'src/redux/selectors/adminSelectors';
import { auth, database, storage } from 'src/firebase';

function* login({ payload, callback }) {
  try {
    const { email, password } = payload;
    const { user } = yield signInWithEmailAndPassword(auth, email, password);
    yield put({ type: types.LOGIN_SUCCESS, data: user });
    notification.close();
    callback?.();
  } catch (error) {
    yield put({ type: types.LOGIN_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

function* logout({ payload, callback }) {
  try {
    yield signOut(auth);
    yield put({ type: types.LOGOUT_SUCCESS });
    notification.close();
    callback?.();
  } catch (error) {
    yield put({ type: types.LOGOUT_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

function* updateProfileAdmin({ payload, callback }) {
  try {
    const { avatar, name, shouldUpdatePassword, currentPassword, newPassword } = payload;
    const { currentUser } = auth;

    // upload avatar if it is updated
    let avatarUrl;
    if (avatar) {
      const coverStoRef = stoRef(storage, `admins/${currentUser.uid}/avatar.jpg`);
      const coverUpload = yield uploadBytes(coverStoRef, avatar.originFileObj);
      avatarUrl = yield getDownloadURL(coverUpload.ref);
    }

    // update name and avatar
    yield updateProfile(currentUser, {
      displayName: name,
      photoURL: avatarUrl
    });

    // update password if it is updated
    if (shouldUpdatePassword) {
      const credential = EmailAuthProvider.credential(currentUser.email, currentPassword);
      yield reauthenticateWithCredential(currentUser, credential);
      yield updatePassword(currentUser, newPassword);
    }

    yield put({ type: types.UPDATE_PROFILE_SUCCESS, data: { ...currentUser } });
    notification.close();
    notification.showSuccess('Success', 3);
    callback?.();
  } catch (error) {
    yield put({ type: types.UPDATE_PROFILE_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

export default function* adminSaga() {
  yield all([
    takeLatest(types.LOGIN_REQUEST, login),
    takeLatest(types.LOGOUT_REQUEST, logout),
    takeLatest(types.UPDATE_PROFILE_REQUEST, updateProfileAdmin),
  ])
}
